import React from 'react';
import styled from 'styled-components';
import { asStyledComponent } from '@clds/component-enhancer';
import { combineValues } from '@clds/component-theme';
import { typographyMixin } from '@clds/typography';
import { formTheme } from './theme.js';
const Root = styled.label `
  display: block;
  ${combineValues(formTheme.label.typography, (props) => typographyMixin(props))};
  margin: ${formTheme.label.margin.vertical} 0;
  cursor: pointer;
`;
const Mandatory = styled.span `
  ${combineValues(formTheme.label.mandatoryTypography, (props) => typographyMixin(props))};
`;
export const Label = asStyledComponent(({ mandatory, children, ...rest }) => (React.createElement(Root, { ...rest },
    children,
    mandatory && React.createElement(Mandatory, null, "\u00A0*"))));
//# sourceMappingURL=Label.js.map